<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Lista prisutnosti na poslu</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label no-print">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
// import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  getStatusCodeFromStatusId,
  getShortTimeFromTicks,
  maskIfEquealsValue,
  getFirstDateOfMonth,
  getLastDateOfMonth,
  shouldEmployeeBeAdded,
} from "../../_helpers/arrangers";
//import //   getDateFromTicks,
//   maskIfEquealsValue,
//   isWorkingDayFromDate,
//"../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
];

export default {
  name: "AbsenceList",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      params: {
        data: [
          [
            "Ndx",
            "Ime i prezime",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "Σ GO",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: "3%" },
          { column: 2, width: 40 },
          { column: 3, width: 40 },
          { column: 4, width: 40 },
          { column: 5, width: 40 },
          { column: 6, width: 40 },
          { column: 7, width: 40 },
          { column: 8, width: 40 },
          { column: 9, width: 40 },
          { column: 10, width: 40 },
          { column: 11, width: 40 },
          { column: 12, width: 40 },
          { column: 13, width: 40 },
          { column: 14, width: 40 },
          { column: 15, width: 40 },
          { column: 16, width: 40 },
          { column: 17, width: 40 },
          { column: 18, width: 40 },
          { column: 19, width: 40 },
          { column: 20, width: 40 },
          { column: 21, width: 40 },
          { column: 22, width: 40 },
          { column: 23, width: 40 },
          { column: 24, width: 40 },
          { column: 25, width: 40 },
          { column: 26, width: 40 },
          { column: 27, width: 40 },
          { column: 28, width: 40 },
          { column: 29, width: 40 },
          { column: 30, width: 40 },
          { column: 31, width: 40 },
          { column: 32, width: 40 },
          { column: 33, width: 40 },
        ],
        highlight: { column: [-1] },
        highlightedColor: colors[4],
      },
      departments: [],
      seletedDepartment: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);

    // this.getDepartments(); // Ovo ne treba ovdje da se poziva već svaki put kad se izabere datum.
  },
  methods: {
    tableCellClicked() {},
    resetUi() {
      this.params.data = [
        [
          "Ndx",
          "Ime i prezime",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "Σ GO",
        ],
      ];
      this.dailyLogs = [];
      this.departmentData = [];
    },
    async monthChosen(mnth) {
      console.log(mnth);

      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();

      // calculate date for first day this month
      this.firstDay = getFirstDateOfMonth(
        this.selectedMonth,
        this.selectedYear
      );
      this.lastDay = getLastDateOfMonth(this.selectedMonth, this.selectedYear);

      console.log(this.selectedMonth);
      console.log(this.selectedYear);

      await this.getDepartments(); // Ovo ne treba ovdje da se poziva već svaki put kad se izabere datum.
    },
    async getDepartments() {
      // UserService.getDepartments().then((response) => {
      //   // reset ui
      //   this.departmentData = response.data;
      //   this.arrangeSectors(response.data);
      // });
      let response =
        await ReportService.GetAllDepartmentsOfMyCompanyHistoricallyByMonth(
          this.selectedMonth,
          this.selectedYear
        );
      // reset ui
      this.departmentData = response.data;
      this.arrangeSectors(response.data);
      console.log("department data sectors: ", response.data);
      console.log("departments: ", this.departments);
    },
    arrangeSectors(data) {
      this.departments = [];
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    getData(departmentId, month, year) {
      console.log("getData");
      ReportService.GetDailyLogsByDepartmentIdAndMonth(
        departmentId,
        month,
        year
      ).then((response) => {
        console.log("daily logs 1?");
        console.log(response.data);
        this.calculateData(response.data);
        this.pushData();
      });
    },
    calculateData(data) {
      // first add days array to employees
      console.log("employees:", this.employees);
      this.employees.forEach((emp) => {
        emp.days = new Array(31).fill(0);
        emp.total = 0;
      });
      data.forEach((dlog) => {
        // console.log("proba1");
        console.log(dlog);
        // who I belong to?
        let emplyoee = this.employees.find(
          (e) => e.employeeId === dlog.employeeId
        );
        // what day is it?
        let day = new Date(dlog.logDate).getDate();
        let stat = getStatusCodeFromStatusId(
          dlog.statusId,
          dlog.statusIdOverride,
          this.$store.state.general.statuses
        );
        // don't show Sunday
        if (dlog.logDay === 0 && stat.startsWith("SN")) {
          stat = "  ";
        }
        if (dlog.statusId === 2) {
          emplyoee.total++;
        }

        // let late = getShortTimeFromTicks(dlog.lateWorkhours);
        console.log(emplyoee);
        console.log(day);
        console.log(getShortTimeFromTicks(dlog.lateWorkhours));
        // populate days
        emplyoee.days[day - 1] = stat;
      });
    },
    pushData() {
      let ndx = 1;

      this.employees.forEach((emp) => {
        let startDate = new Date(emp.startDate);
        let endDate = emp.endDate
          ? new Date(emp.endDate)
          : new Date("3000-01-01");

        let startDatePass = false;
        let endDatePass = false;
        let pass = true;

        if (startDate < this.lastDay) {
          startDatePass = true;
        }

        if (endDate > this.firstDay) {
          endDatePass = true;
        }

        if (!startDatePass || !endDatePass) {
          pass = false;
        }

        if (emp.firstName === "Anđela") {
          console.log(startDate);
          console.log(this.lastDay);
        }

        if (pass) {
          this.params.data.push([
            ndx++,
            emp.firstName + " " + emp.lastName,
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[0], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[1], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[2], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[3], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[4], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[5], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[6], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[7], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[8], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[9], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[10], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[11], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[12], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[13], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[14], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[15], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[16], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[17], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[18], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[19], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[20], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[21], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[22], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[23], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[24], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[25], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[26], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[27], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[28], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[29], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(
              maskIfEquealsValue(emp.days[30], "NN        "),
              "NN        "
            ),
            maskIfEquealsValue(emp.total, "0"),
          ]);
        }
      });
    },
    async departmentSelected() {
      this.resetUi();

      await this.getDepartments(); // Ovo ne treba ovdje da se poziva već svaki put kad se izabere datum.

      let departmentId = this.seletedDepartment.id;

      let allEmployees = this.departmentData.find((d) => {
        return d.departmentId === departmentId;
      }).employee;

      this.employees = [];
      allEmployees.forEach((emp) => {
        if (shouldEmployeeBeAdded(emp, this.selectedMonth, this.selectedYear)) {
          this.employees.push(emp);
        }
      });

      this.getData(departmentId, this.selectedMonth, this.selectedYear);
    },
  },
};
</script>

<style scoped>
.ex1 {
  margin-top: 30px;
}
.cmitem {
  /* margin: 20px;
  border-color: blue;
  border-width: 2px; */
  width: 150px;
  border: none;
  background-color: inherit;
  padding: 14px 28px;
  font-size: 12px;
  cursor: pointer;
  display: inline-block;
}

/* .base-demo {
  width: 2700px;
} */

.cmitem:hover {
  background: #c3ffeb;
}

.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}
.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 0px !important;
  /* flex: 0 0 0 0px !important; */
}
</style>
